<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>积分订单管理</span>
        <el-button :loading="loading" @click="loadData">刷新</el-button>
      </div>

      <el-form :inline="true" :model="query" class="query-form">
        <el-form-item>
          <el-input v-model.trim="query.orderNo" placeholder="订单号" clearable />
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="query.receiverMobile" placeholder="收货手机号" clearable />
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.orderStatus" placeholder="订单状态" clearable>
            <el-option label="待发货" :value="0" />
            <el-option label="待收货" :value="1" />
            <el-option label="已完成" :value="2" />
            <el-option label="已取消" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" @click="loadData">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border v-loading="loading">
        <el-table-column prop="orderNo" label="订单号" min-width="220" />
        <el-table-column prop="receiverName" label="收货人" width="120" />
        <el-table-column prop="receiverMobile" label="手机号" width="140" />
        <el-table-column prop="pointsAmount" label="消耗积分" width="120" />
        <el-table-column label="订单状态" width="120">
          <template slot-scope="{ row }">
            <el-tag :type="statusType(row.orderStatus)">{{ statusText(row.orderStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="180">
          <template slot-scope="{ row }">{{ formatDateTime(row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="goDetail(row.orderNo)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="table-footer">
        <div class="table-footer__meta">共 {{ total }} 条</div>
        <el-pagination
          background
          layout="prev, pager, next, sizes"
          :current-page="query.pageNum"
          :page-sizes="[10, 20, 50]"
          :page-size="query.pageSize"
          :total="total"
          @current-change="changePage"
          @size-change="changePageSize"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getPointOrderPage } from '../../api/admin'
import { formatDateTime } from '../../utils/format'

const QUERY_KEY = 'mall_admin_point_order_query'

export default {
  data() {
    return {
      query: {
        orderNo: '',
        receiverMobile: '',
        orderStatus: '',
        pageNum: 1,
        pageSize: 20
      },
      list: [],
      total: 0,
      loading: false
    }
  },
  created() {
    this.restoreQuery()
    this.loadData()
  },
  methods: {
    formatDateTime,
    statusText(status) {
      const map = { 0: '待发货', 1: '待收货', 2: '已完成', 3: '已取消' }
      return map[status] || '未知状态'
    },
    statusType(status) {
      const map = { 0: 'primary', 1: 'warning', 2: 'success', 3: 'info' }
      return map[status] || 'info'
    },
    async loadData() {
      this.loading = true
      try {
        const data = await getPointOrderPage(this.query)
        this.list = data.list || []
        this.total = data.total || 0
      } finally {
        this.loading = false
      }
      this.persistQuery()
    },
    persistQuery() {
      sessionStorage.setItem(QUERY_KEY, JSON.stringify(this.query))
    },
    restoreQuery() {
      const saved = this.$route.query.q || sessionStorage.getItem(QUERY_KEY)
      if (!saved) {
        return
      }
      try {
        this.query = { ...this.query, ...JSON.parse(saved) }
      } catch (error) {
        sessionStorage.removeItem(QUERY_KEY)
      }
    },
    resetQuery() {
      this.query = {
        orderNo: '',
        receiverMobile: '',
        orderStatus: '',
        pageNum: 1,
        pageSize: 20
      }
      this.loadData()
    },
    changePage(page) {
      this.query.pageNum = page
      this.loadData()
    },
    changePageSize(size) {
      this.query.pageSize = size
      this.query.pageNum = 1
      this.loadData()
    },
    goDetail(orderNo) {
      this.$router.push({
        path: `/point-mall/orders/${orderNo}`,
        query: { q: JSON.stringify(this.query) }
      })
    }
  }
}
</script>

<style scoped>
.card-header { display: flex; justify-content: space-between; align-items: center; }
.query-form { margin-bottom: 12px; }
.table-footer { display: flex; justify-content: space-between; align-items: center; margin-top: 16px; }
.table-footer__meta { color: #6b7280; font-size: 13px; }
</style>
